import { instance } from "libs/api";

import { ApiRoutesPacks } from "../../constants";
import { Pack } from "../../packs.types";
import { UpdatePackRequestBody } from "./updatePack.types";

export const requestUpdatePack = async (
  body: UpdatePackRequestBody
): Promise<Pack> => {
  return await instance.put(ApiRoutesPacks.Packs, body);
};
